import { game_session_activity } from './api/entities';

export const actions = {
  resetGameSessionActivityState: 'RESET_GAME_SESSION_ACTIVITY_STATE',
  createGameSessionActivity: 'CREATE_GAME_SESSION_ACTIVITY',
  updateGameSessionActivity: 'UPDATE_GAME_SESSION_ACTIVITY',
  listGameSessionActivity: 'LIST_GAME_SESSION_ACTIVITY',
  getGameSessionActivity: 'GET_GAME_SESSION_ACTIVITY',
};

export function resetGameSessionActivityState() {
  return { type: actions.resetGameSessionActivityState };
}

export function createGameSessionActivity(gameSessionObject) {
  return game_session_activity.create(actions.createGameSessionActivity, gameSessionObject, []);
}

export function updateGameSessionActivity(game_session_activityId, gameSessionObject) {
  return game_session_activity.update(
    actions.updateGameSessionActivity,
    game_session_activityId,
    gameSessionObject,
    []
  );
}

export function getGameSessionActivities(query, sort) {
  return game_session_activity.list(actions.listGameSessionActivity, query, sort);
}

export function getGameSessionActivity(game_session_activityId) {
  return game_session_activity.get(actions.getGameSessionActivity, game_session_activityId, []);
}

const INITIAL_STATE = {
  game_session_activities: [],
  game_session_activity: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.resetGameSessionActivityState:
      return {
        ...INITIAL_STATE,
      };
    case actions.createGameSessionActivity:
      return {
        ...state,
        game_session_activities: action.body
          ? [...state.game_session_activities, action.body]
          : state.game_session_activities,
      };
    case actions.listGameSessionActivity:
      return {
        ...state,
        game_session_activities: action.body ? action.body._items : state.game_session_activities,
      };
    case actions.getGameSessionActivity:
      return {
        ...state,
        game_session_activity: action.body ? action.body : state.game_session_activity,
      };
    case actions.updateGameSessionActivity:
      return {
        ...state,
        id: action.body ? action.body : null,
      };
    default:
      return {
        ...state,
      };
  }
}
